import React from 'react';
import PropTypes from 'prop-types';
import './Footer.css';


const Footer = ({ toggleAbout, toggleContactUs }) => {
  return (
    <footer>
      <ul>
        <li
          onClick={toggleAbout}
        >
          About the map
        </li>
        <li
          onClick={toggleContactUs}
        >
          Contact us
        </li>
      </ul>

    </footer>
  );
};

export default Footer;

Footer.propTypes = {
  aboutOpen: PropTypes.bool,
  toggleAbout: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Footer.jsx